/**
 * Popular Material Icons for notes/folders
 */
export const MATERIAL_ICONS = [
  // Documents & Notes
  'description',
  'article',
  'note',
  'sticky_note_2',
  'text_snippet',
  'drafts',
  'edit_note',
  'content_paste',
  'assignment',
  'library_books',
  'menu_book',
  // Folders & Organization
  'folder',
  'folder_open',
  'folder_special',
  'create_new_folder',
  'snippet_folder',
  'source',
  'inventory_2',
  'category',
  'label',
  'bookmark',
  'bookmarks',
  // People & Characters
  'person',
  'people',
  'group',
  'groups',
  'face',
  'sentiment_satisfied',
  'psychology',
  'self_improvement',
  'accessibility_new',
  'emoji_people',
  // Fantasy & Gaming
  'castle',
  'fort',
  'shield',
  'security',
  'military_tech',
  'sports_martial_arts',
  'whatshot',
  'local_fire_department',
  'bolt',
  'flash_on',
  'auto_awesome',
  'diamond',
  'stars',
  'star',
  'grade',
  'workspace_premium',
  // Nature & Creatures
  'pets',
  'cruelty_free',
  'pest_control',
  'bug_report',
  'nature',
  'park',
  'forest',
  'landscape',
  'terrain',
  'water',
  'waves',
  'air',
  // Locations & Maps
  'place',
  'location_on',
  'pin_drop',
  'map',
  'explore',
  'travel_explore',
  'public',
  'language',
  'home',
  'cottage',
  'house',
  'apartment',
  'store',
  'storefront',
  'temple_hindu',
  'temple_buddhist',
  'church',
  'mosque',
  // Items & Objects
  'inventory',
  'backpack',
  'work',
  'handyman',
  'construction',
  'build',
  'key',
  'vpn_key',
  'lock',
  'lock_open',
  'savings',
  'paid',
  'redeem',
  'card_giftcard',
  'local_drink',
  'wine_bar',
  'restaurant',
  // Actions & Combat
  'gavel',
  'sports_kabaddi',
  'directions_run',
  'directions_walk',
  'accessibility',
  'healing',
  'medication',
  'medical_services',
  'health_and_safety',
  // Magic & Mystery
  'auto_fix_high',
  'blur_on',
  'flare',
  'filter_vintage',
  'lens_blur',
  'nightlight',
  'dark_mode',
  'light_mode',
  'brightness_7',
  'visibility',
  // Time & Calendar
  'schedule',
  'access_time',
  'event',
  'today',
  'calendar_month',
  'history',
  'update',
  'hourglass_empty',
  'timer',
  'alarm',
  // Communication
  'chat',
  'forum',
  'comment',
  'sms',
  'mail',
  'send',
  'campaign',
  'announcement',
  'notification_important',
  'priority_high',
  // Misc
  'help',
  'info',
  'warning',
  'error',
  'check_circle',
  'cancel',
  'favorite',
  'thumb_up',
  'emoji_objects',
  'lightbulb',
  'tips_and_updates'
]

export default MATERIAL_ICONS
